import React from 'react';
import moment from 'moment';
import { strings } from 'APP_ROOT/localization';

/* Calendar component

 - Remember's the month the user is currently on
 - When changing the month, doesn't change the currently selected date
 - The currently selected date is a prop, and isn't stored internally
 - Calls a prop function whenever the user clicks on a new day that has data
     - Does nothing if the day doesn't have any data
*/

export default class Calendar extends React.PureComponent {

    constructor(props) {

        super(props);

        this.state = {
            monthDate: props.selectedDate ? props.selectedDate : new Date()
        };
    }

    //takes months 0-11, converts to 1-12
    daysInMonth(year, month) {
        return new Date(year, month + 1, 0).getDate();
    }

    offsetCalendarMonth = (offset) => {
        this.setState(state => {
            const newMonthDate = new Date(state.monthDate);
            newMonthDate.setMonth(newMonthDate.getMonth() + offset);
            return { monthDate: newMonthDate }
        });
    }

    goToToday = (e) => {
        const today = new Date();
        const monthDate = new Date();
        monthDate.setDate(1);
        if (this.props.onDateChanged) this.props.onDateChanged(today);
        this.setState({monthDate});
    }

    onCalendarDayClick = (e, dayOfMonth) => {
        e.preventDefault();
        const { monthDate } = this.state;
        const targetDate = new Date(monthDate.getFullYear(), monthDate.getMonth(), dayOfMonth);
        if (this.props.onDateChanged) this.props.onDateChanged(targetDate);
    }

    render() {

        var monthDate = this.state.monthDate;
        var targetYear = monthDate.getFullYear();
        var targetMonth = monthDate.getMonth();
        var monthStartDay = new Date(targetYear, targetMonth, 1).getDay();
        var daysInMonth = this.daysInMonth(targetYear, targetMonth);

        var days = []; //create a calendar div for each day and give it a day number - ?including the previous month and next month's dates to fill in calendar start and end?
        for (var i = 0; i < 7 * 6; i++) {
            var day = {};
            var actualDate = i - monthStartDay + 1;
            if (i >= monthStartDay && actualDate <= daysInMonth) {
                day.number = actualDate;
            }
            days.push(day);
        }

        var curDate = this.props.selectedDate;
        var renderDays = days.map((day, i) => {
            var actualDate = i - monthStartDay + 1;
            var dayClassName = [];
            if (curDate && curDate.getDate() === actualDate &&
                curDate.getFullYear() === targetYear &&
                curDate.getMonth() === targetMonth) {
                dayClassName.push("selected-date");
            }
            if (day.number) dayClassName.push("selectable");
            if (moment(new Date(targetYear, targetMonth, day.number)).format('MMMM YYYY DDDD') === moment(new Date()).format('MMMM YYYY DDDD')) {
                dayClassName.push('today');
            }

            const cardStartDate = card => new Date(card.start.ts);

            // Highlight if requested
            if (this.props.highlight) {
                var highlight = false;
                this.props.highlight.filter((highdate, index) => {
                    var targetDate = cardStartDate(highdate);

                    if (targetDate.getDate() === day.number &&
                        targetDate.getMonth() === monthDate.getMonth() &&
                        targetDate.getFullYear() === monthDate.getFullYear()) {
                        highlight = true;
                    }
                });

                if (highlight)
                    dayClassName.push('highlighted-date');
            }

            // Render dots
            // TODO JW 2019-04-10: burn all this logic to the ground.
            // We should be calculating counts and then rendering an array of divs based on the count.
            // You could even reuse the 4 different rendered variants then (one dot, two dots, etc).
            // And what's with using filter as a forEach?
            // I MEAN COME ON. Anything but this!

            var renderDots = [];
            if (this.props.cards) {
                this.props.cards.filter((card, index) => {
                    var targetDate = cardStartDate(card);

                    if (card.type === 'TRIP' &&
                        targetDate.getDate() === day.number &&
                        targetDate.getMonth() === monthDate.getMonth() &&
                        targetDate.getFullYear() === monthDate.getFullYear()) {
                        renderDots.push(<div className='dot' key={index}></div>);
                    }
                });
            }
            if (renderDots.length == 0) {
                dayClassName.push('no-data');
            }
            if (renderDots.length > 3) {
                renderDots = [
                    <div className="dot" key={0}></div>,
                    <div className="dot" key={1}></div>,
                    <div className="dot" key={2}></div>,
                    <div className="dot plus" key={3}>+</div>
                ];
            }
            var calendarDayClasses = ["calendar-day"];
            if (renderDots.length === 0) calendarDayClasses.push("no-data");

            return (
                <div className={calendarDayClasses.join(' ')} key={i}>
                    <a onClick={(e) => this.onCalendarDayClick(e, day.number)} href={renderDots.length > 0 ? '#' + day.number : ''} className={dayClassName.join(' ')} tabIndex={day.number ? "" : "-1"}>
                        <span>{day.number ? day.number : ''}</span>
                        <div className="dot-container">
                            {renderDots}
                        </div>
                    </a>
                </div>
            );
        });

        var renderDayOfWeekLabels = [];
        for (var i = 0; i < 7; i++) {
            renderDayOfWeekLabels.push(<div className="day-of-week-label" key={i}>{moment.weekdays(i).slice(0, 1)}</div>);
        }

        var calendarClassList = ['calendar-month']
        return (
            <div id="calendar" className={calendarClassList.join(" ")}>
                <div className="calendar-month-header">
                    <h2>{moment(monthDate).format('MMMM')} <span className="d-inline-block">{moment(monthDate).format('YYYY')}</span></h2>
                    <div className="button-container">
                        <button onClick={() => this.offsetCalendarMonth(-1)} alt="prev-month"><i className="material-icons">keyboard_arrow_left</i></button>
                        <button onClick={() => this.offsetCalendarMonth(1)} alt="next-month"><i className="material-icons">keyboard_arrow_right</i></button>
                        <button onClick={this.goToToday} className="btn-today" alt="go to today">{strings.date_picker_options_today_label}</button>
                    </div>
                </div>
                <div className="calendar-month-days">
                    {renderDayOfWeekLabels}
                    {renderDays}
                </div>
            </div>
        );
    }
}
